import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Tabs, Card } from 'antd'
import { StickyContainer, Sticky } from 'react-sticky'
import {
  Container,
  Row,
  Col,
  Spin,
  Divider,
  Text,
  Img,
  Title
} from '@qonsoll/react-design'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useDocument } from 'hooks'
import { useStateWithStorage } from 'hooks'

const FeatureAdvancedView = (props) => {
  // [COMPONENT_STATE_HOOKS]
  const [activeTab, setActiveTab] = useStateWithStorage(
    null,
    'feature-advanced-view-active-tab'
  )

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const params = useParams()
  const location = useLocation()
  const { featureId } = params
  const [feature, loading] = useDocument({ ref: `features/${featureId}` })

  // [COMPUTED_PROPERTIES]
  const { TabPane } = Tabs

  return loading ? (
    <Spin />
  ) : (
    <Container>
      <Container mb={4}>
        <Card>
          <Row noGutters mb={2} v="center">
            <Col h="left">
              <Img
                style={{
                  maxHeight: '500px',
                  objectFit: 'cover',
                  width: '100%'
                }}
                src={feature?.featureLogoURL}
              />
            </Col>
          </Row>
          <Row noGutters mb={2} v="center">
            <Col h="left">
              <Title level={3}>{feature?.name}</Title>
            </Col>
          </Row>
          <Row noGutters v="center">
            <Col h="left">
              <Text variant="overline" type="secondary">
                {t('Estimation')}:
              </Text>
            </Col>
            <Col h="right">
              <Text>{feature?.estimation}</Text>
            </Col>
            <Divider my={2} />
          </Row>
        </Card>
      </Container>
    </Container>
  )
}

FeatureAdvancedView.propTypes = {}

export default FeatureAdvancedView
